import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import { useToast } from '@givebutter/primitives/toast';
import { createWidget } from 'api/widgets';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { Widget, WidgetType } from 'types/domain';
import { GivebutterAxiosError } from 'types/error';

const useCreateWidgetMutation = (
    options: UseMutationOptions<
        Widget,
        unknown,
        { widgetType: WidgetType; campaignId: number },
        any
    > = {},
) => {
    const { onError, ...rest } = options;
    const toast = useToast();
    const { accountId } = useCurrentAccount();

    return useMutation({
        mutationFn: ({ widgetType, campaignId }) =>
            createWidget({
                accountId,
                widgetConfig: {
                    type: widgetType,
                    campaign_id: campaignId,
                },
            }),
        onError: (error: GivebutterAxiosError, vars, context) => {
            toast.error(<>{error.response?.data.message ?? 'Unknown error initializing widget'}</>);
            onError?.(error, vars, context);
        },
        ...rest,
    });
};

export { useCreateWidgetMutation };
